import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';

function LeftAds() {    
    var LeftADV = "";

    const desktop_left = useSelector((state) => state.HomeBucket.bucket.data.ads.desktop_left);
    const dispatch = useDispatch();

    function openModal() {
       dispatch( allActions.ModalPopup.showPopupByPopupName({ popupname:desktop_left.popupname}));
    }


    if(desktop_left.popupname){
        LeftADV = () => <button onClick={() => openModal()}><div dangerouslySetInnerHTML={{__html: desktop_left.data}} /></button>
     }else{
        LeftADV = () => <div dangerouslySetInnerHTML={{__html: desktop_left.data}} />
     }
   
    return (
    <>
     <div className="left-ads-section desktop-screen-show">

            <LeftADV />
                    
        </div>
    </>
    );
}

  
  
  export default LeftAds;